<template>
  <div class="park-detail-info-place">
    <!-- <div class="park-detail-info-sub-title">◇位置</div> -->
    <div v-loading="mapLoading" class="park-detail-info-place-content">
      <tz-map
        v-if="detail.id"
        :ref="'placeTzMap' + detail.id"
        :position="position"
        :container="'placeMapView' + detail.id"
        mw="100%"
        mh="100%"
        :maxZoom="18"
      >
        <tz-toggle-map :base-list="configList" :is-note="true" />
      </tz-map>
    </div>
  </div>
</template>
<script>
// 地块位置组件

export default {
  name: "LandPlace",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      position: [100.264162, 25.615269],
      configList: mapConfig.configList,
      mapView: undefined,
      mapLoading: false,
    };
  },
  watch: {
    detail: function (val) {
      if (val) {
        this.onLandLocation(this.info.shapeInfo, val.name);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.mapView = this.$refs["placeTzMap" + this.detail.id].tzApi;
      if (this.detail.name) {
        this.onLandLocation(
          // .pronouncePolygons
          this.info.shapeInfo,
          this.detail.name
        );
      }
    });

    // this.getLandDetail(this.landId);
  },
  methods: {
    //用地定位
    onLandLocation(arr, name) {
      if (!arr || !arr.length) {
        return false;
      }
      this.mapView.removeVectorFeatureById("landId");
      let len = arr.length;
      let allPolygon = [];
      for (const item of arr) {
        allPolygon.push(item.geom.coordinates[0]);
      }
      this.mapView.addVectorMultiPolygon(
        allPolygon,
        name,
        { id: "landId" },
        "#0a8708",
        "rgba(0,0,0,0)",
        "#0a8708",
        "#ffffff",
        undefined,
        undefined,
        3
      );
      let extent = this.mapView.getMultiPolygonExtent(allPolygon);
      this.mapView.zoomToExtent(extent[0], extent[1], extent[2], extent[3]);
    },
  },
};
</script>
<style scoped>
.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.park-detail-info-place-content {
  width: calc(100% - 2px);
  height: 450px;
}
</style>
